import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './auth.service';

export const toolGuard: CanMatchFn = async (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = await firstValueFrom(auth.loadSession());
  const toolId = Number(route.data?.['toolId']);

  return user?.tool_ids?.includes(toolId)
    ? true
    : router.createUrlTree(['/dashboard']);
};
